<template>
    <div class="page" ref="appMFormula">
        <router-stage></router-stage>
        <!-- <div class="scroll" ref="scroll"> -->
        <img src="https://oss.eventnet.cn/H5/72Hours/img/logo.png" class="logo">
        <div class="hours"></div>
        <div class="slogan"></div>
        <img src="https://oss.eventnet.cn/H5/72Hours/image/mobile/title-demo.png" class="title-demo">
        <ul class="game-list">
            <li v-for="(item, index) in formulaList1" :key="index" v-show="formulaList1.length > 0">
                <img :src="item.image" alt="">
                <div class="title">{{ item.title }}</div>
            </li>
        </ul>
        <img src="https://oss.eventnet.cn/H5/72Hours/image/mobile/title-originality.png" class="title-originality">
        <ul class="game-list">
            <li v-for="(item, index) in formulaList2" :key="index" v-show="formulaList1.length > 0">
                <img :src="item.image" alt="">
                <div class="title">{{ item.title }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
import { is_mobile } from '../Toolset'
import UserAgreement from './UserAgreement.vue';
export default {
    components: { UserAgreement },
    name: "MFormula",
    data() {
        return {
            isMac: false, // 是否苹果系统，倒计时文字高度上下居中
            gameList: [
                {
                    title: 'AKA进击的巨人的巨人AKA进击巨人的巨人',
                    image: 'https://oss.eventnet.cn/H5/72Hours/image/seize.jpg',
                    vote: '6666'
                }, {
                    title: 'AKA进击的巨人的巨人',
                    image: 'https://oss.eventnet.cn/H5/72Hours/image/seize.jpg',
                    vote: '6666'
                }
            ],
            openid: null,
            userAgreement: false,
            formulaList1: [],
            formulaList2: [],
            votePopup: false,
            imageArr: [],
            isSwiper: false,
            voteContent: {
                arrId: '', // 当前文章所在列表的坐标
                uuid: '', // 用户id
                track: '2', // 所属赛道
                image: '', // 图片
                title: '', // 游戏名称
                type: '', // 标签、游戏类型
                introduction: '', // 游戏简介、游戏世界观设定
                setting: '', // 游戏平台、角色设定
                core: '', // 安装及试玩方法、游戏核心机制
                down: '' // 全栈赛道
            },
        };
    },
    created() {
        const THAT = this;
        if (!is_mobile()) {
            // console.log('😁是否手机端', is_mobile());
            THAT.$router.replace("/Formula");
        }
        THAT.openid = localStorage.getItem('hose72-wwx3-2wzf-uuid') || null;
        THAT.formulaApi();
    },
    mounted() {
        const THAT = this;
        THAT.$refs.appMFormula.scrollIntoView();
    },
    methods: {
        formulaApi() {
            const THAT = this;
            THAT.axios
                .post('Works/final/')
                .then(res => {
                    console.log('发布成功 ====>>>', res.data);
                    if (res.data.code == 200) {
                        for (let i = 0; i < res.data.data.length; i++) {
                            // console.log(res.data.data[i]);
                            let formulaObj1 = {
                                image: res.data.data[i].image.split('||')[0],
                                number: res.data.data[i].number,
                                title: res.data.data[i].title,
                                uuid: res.data.data[i].uuid
                            }
                            THAT.formulaList1.push(formulaObj1);
                        }
                        for (let i = 0; i < res.data.data2.length; i++) {
                            // console.log(res.data.data[i]);
                            let formulaObj2 = {
                                image: res.data.data2[i].image.split('||')[0],
                                number: res.data.data2[i].number,
                                title: res.data.data2[i].title,
                                uuid: res.data.data2[i].uuid
                            }
                            THAT.formulaList2.push(formulaObj2);
                        }
                    }

                })
                .catch(error => {
                    console.log(error);
                    // console.log(error.response);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    position: relative;
    width: 750px;
    // height: 7925px;
    background: url('https://oss.eventnet.cn/H5/72Hours/img/bg-2.jpg') no-repeat;
    background-size: 750px 7372px;
    padding-top: 437px;
    padding-bottom: 520px;

    img {
        display: block;
    }

    .logo {
        position: absolute;
        top: 124px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        pointer-events: none;
    }

    .hours {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 750px;
        height: 773px;
        background: url('https://oss.eventnet.cn/H5/72Hours/img/72-hours3.png') no-repeat;
        background-size: 100% 100%;
    }

    .slogan {
        position: relative;
        z-index: 2;
        width: 750px;
        height: 853px;
        background: url('https://oss.eventnet.cn/H5/72Hours/img/slogan2.png') center no-repeat;
        background-size: 535px 853px;
    }

    .title-demo,
    .title-originality {
        width: 683px;
        height: 247px;
        margin: 35px auto 75px;
        pointer-events: none;
    }

    .title-originality {
        height: 245px;
        margin-top: 5px;
    }





    .game-list {
        width: 674px;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        li {
            width: 527px;
            margin-bottom: 50px;

            img {
                width: 527px;
                height: 280px;
                display: block;
                border: solid 4px #34f2ec;
            }

            .title {
                // border: solid 1px red;
                padding: 20px 5px;
                font-size: 26px;
                line-height: 1.5;
                text-align: center;
            }

        }
    }
}

.page::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
    width: 750px;
    height: 500px;
    display: block;
    // border: solid 5px yellow;
    background: url('https://oss.eventnet.cn/H5/72Hours/image/mobile/bg-footer.png') bottom no-repeat;
    background-size: 750px 333px;
}
</style>



// WEBPACK FOOTER //
// src/components/MFormula.vue